import type { ComplaintCategory } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Label } from '~/components/ui/label'
import { COMPLAINT_CATEGORY_KEYS } from '~/pages/backoffice/admin/complaints/complaint-labels'

/**
 * Nature d'une demande d'apprenant (#325) : elle la classe au registre des
 * réclamations de son organisme. Le signalement (violences, harcèlement,
 * discrimination, V10) dit qui le lira : les administrateurs, jamais les formateurs.
 */
function ContactCategoryField({ value, onChange }: { value: ComplaintCategory, onChange: (value: ComplaintCategory) => void }) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="contactCategory">{t('contact.category')}</Label>
      <select
        id="contactCategory"
        value={value}
        onChange={e => onChange(e.target.value as ComplaintCategory)}
        aria-describedby="contactCategoryHelp"
        className="h-10 rounded-md border border-input bg-transparent px-3 text-sm"
      >
        {Object.entries(COMPLAINT_CATEGORY_KEYS).map(([key, label]) => <option key={key} value={key}>{t(label)}</option>)}
      </select>
      <p id="contactCategoryHelp" className="text-xs text-muted-foreground">{t('contact.category.help')}</p>
    </div>
  )
}

export default ContactCategoryField
